var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.167 2.916H5.834c-2.5 0-4.167 1.25-4.167 4.167v5.833c0 2.917 1.667 4.167 4.167 4.167h8.333c2.5 0 4.167-1.25 4.167-4.167V7.083c0-2.917-1.667-4.167-4.167-4.167m.392 5.075-2.609 2.083c-.55.442-1.25.659-1.95.659s-1.408-.217-1.95-.659L5.442 7.991a.64.64 0 0 1-.1-.883.623.623 0 0 1 .875-.1L8.825 9.09c.634.508 1.709.508 2.342 0l2.608-2.083a.615.615 0 0 1 .875.1.63.63 0 0 1-.091.883"
  })));
};
export default SvgMail;